import { render, staticRenderFns } from "./WuhanBaseInfoNew.vue?vue&type=template&id=0309cb10&scoped=true&"
import script from "./WuhanBaseInfoNew.vue?vue&type=script&lang=js&"
export * from "./WuhanBaseInfoNew.vue?vue&type=script&lang=js&"
import style0 from "./WuhanBaseInfoNew.vue?vue&type=style&index=0&id=0309cb10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309cb10",
  null
  
)

export default component.exports